import React, {useEffect, useState} from "react";
import ProfileHeader from "../Headers/ProfileHeader";
import {Button, Dropdown, DropdownButton} from "react-bootstrap";
import {
  deleteConversationPrompt,
  destroyConversation,
  getConversation,
  getConversations,
  newConversation,
  newConversationPrompt,
  putConversation,
  putConversationPrompt,
  putConversationPromptPosition
} from "../../lib/api";
import {EditableText, EditableTextArea} from "../Shared/EditableWidgets";
import {TrashButton} from "../Shared/Buttons";
import * as Icon from "react-bootstrap-icons";
import EditConversationConfig from "./EditConversationConfig";
import ConversationsInstructions from "./ConversationsInstructions";
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import ConfirmDelete from "../Shared/ConfirmDelete";
import {ErrorMessageType} from "../../lib/types";


function DropDownConversations(props: {
  setConversation: any,
  conversations: Conversation[],
  conversation: NullableConversation,
  add: any,
  setShowEditConfig: any,
  toggleInstructions: any,
  refreshConversations: any,
  saveError: any,
}) {
  const {
    conversations,
    setConversation,
    conversation,
    add,
    setShowEditConfig,
    toggleInstructions,
    refreshConversations,
    saveError
  } = props;
  const items = conversations.map((conversation: any) =>
    <Dropdown.Item key={`conversation-${conversation.id}`}
                   onClick={() => setConversation(conversation)}>{conversation.name}</Dropdown.Item>
  );
  const [showConfirmDestroy, setShowConfirmDestroy] = useState(false);
  const title = conversation ? conversation.name : "Choose conversation to edit";

  function confirmDestroy() {
    setShowConfirmDestroy(true);
  }

  function hideConfirmDestroy() {
    setShowConfirmDestroy(false);
  }

  function destroy() {
    if (!conversation) {
      return;
    }
    setShowConfirmDestroy(false);
    destroyConversation(conversation.id)
      .then((response) => {
        if (response.ok) {
          refreshConversations()
          setConversation(null)
        } else {
          response.json().then(json => {
            saveError(json);
          });
        }
      })
  }

  return (
    <div className="row flex-nowrap align-items-end align-items-baseline">
      <ConfirmDelete title={`Delete this Conversation?`}
                     confirm={destroy}
                     show={showConfirmDestroy}
                     onHide={hideConfirmDestroy}
      />
      <div className="col-1">
        <div className="col text-center pl-0">
          <a href="/instructions" className="underline" onClick={toggleInstructions}>Instructions</a>
        </div>
      </div>
      <div className="col-10">
        <div className="d-flex justify-content-center align-items-center">
          <Dropdown onClick={(e: any) => e.stopPropagation()} className="pl-4">
            <DropdownButton menuAlign="left" title={title}>
              {items}
              <Dropdown.Divider/>
              <Dropdown.Item key="create_conversation" onClick={add}>
                New Conversation…
              </Dropdown.Item>
            </DropdownButton>
          </Dropdown>
          {conversation ? <span className="ml-3"><TrashButton onClick={() => confirmDestroy()} visible/></span> : null}
        </div>
      </div>
      <div className="col-1">
        {conversation ?
          <div className="col text-center" onClick={() => setShowEditConfig(true)}>
            <Icon.GearFill size={20}/>
          </div> : null}
      </div>
    </div>
  );
}

interface ConversationPrompt {
  id: string;
  message: string;
  typeOf: string;
  createdAt: string;
  updatedAt: string;
  conversationId: string;
}

export interface ConversationConfig {
  userResponseWaitTime: number;
  userResponseWaitTimeAfterFirstWord: number;
  aiTaskWaitTime: number;
}

export interface Conversation {
  id: string;
  config: ConversationConfig;
  name: string;
  createdAt: string;
  updatedAt: string;
  conversationPrompts?: ConversationPrompt[]; // Optional array of InnerObject, can be empty
}

export type NullableConversation = Conversation | null;

function DropDownMessageType(props: { typeOf: string, setTypeOf: any }) {
  const {typeOf, setTypeOf} = props;
  const items = ['script', 'openended', 'action'].map((t: string) =>
    <Dropdown.Item key={`type-${t}`}
                   onClick={() => setTypeOf(t)}>{t}</Dropdown.Item>
  );
  return (
    <Dropdown onClick={(e: any) => e.stopPropagation()}>
      <DropdownButton menuAlign="left" title={typeOf}>
        {items}
      </DropdownButton>
    </Dropdown>
  );
}

function ConversationPrompt(props: {
  prompt: ConversationPrompt,
  setPrompt: any,
  deletePrompt: any
}) {
  const {
    prompt,
    setPrompt,
    deletePrompt
  } = props;
  const [typeOf, setTypeOf] = useState(prompt.typeOf);
  const [message, setMessage] = useState(prompt.message);

  function setMessageAndPut(message: string) {
    setMessage(message);
    setPrompt({...prompt, ...{message: message}})
    putConversationPrompt({...prompt, ...{message: message}}).then(response => {
        if (!response.ok) {
          response.json().then(json => {
            console.error('error', json)
            // TODO: backups
          });
        }
      }
    );
  }

  function setTypeOfAndPut(typeOf: string) {
    setTypeOf(typeOf);
    setPrompt({...prompt, ...{typeOf: typeOf}})
    putConversationPrompt({...prompt, ...{typeOf: typeOf}}).then(response => {
        if (!response.ok) {
          response.json().then(json => {
            console.error('error', json)
            // TODO: backups
          });
        }
      }
    );
  }

  const promptId = prompt.id;

  return (
    <li className="d-flex align-items-center">
      <div className="d-flex align-items-center mr-2">
        <Icon.GripVertical size={20} className="mr-1"/>
        <div style={{width: '120px'}}>
          <DropDownMessageType typeOf={typeOf} setTypeOf={setTypeOfAndPut}/>
        </div>
      </div>
      <div className="flex-grow-1">
        <EditableTextArea
          value={message}
          ariaLabel="Message"
          isEditable={true}
          isEditing={true}
          maxLength={2000}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
            setMessageAndPut(event.target.value)
          }
          placeholder="Message"
          setIsEditing={() => {
          }}
          rows={1}
        />
      </div>
      <div className="ml-2">
        <TrashButton onClick={() => deletePrompt(promptId)} visible={true}/>
      </div>
    </li>
  );
}

function ConversationPrompts(props: {
  conversationId: string,
  conversationPrompts: ConversationPrompt[],
  setConversationPrompts: any,
  refreshConversation: () => void // Add this line
}) {
  const {
    conversationId,
    conversationPrompts,
    setConversationPrompts,
    refreshConversation // Add this line
  } = props;

  // Helper function to reorder the prompts array
  const reorder = (list: ConversationPrompt[], startIndex: number, endIndex: number) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  // Handle drag and drop
  const onDragEnd = (result: any) => {
    if (!result.destination) {
      return;
    }

    const reorderedPrompts = reorder(
      conversationPrompts,
      result.source.index,
      result.destination.index
    );

    setConversationPrompts(reorderedPrompts);

    // Find the conversationPrompt that was moved
    const movedPrompt = conversationPrompts[result.source.index];

    // Find the conversationPrompt after which the moved prompt should be positioned
    const positionAfter =
      result.destination.index === 0
        ? null
        : reorderedPrompts[result.destination.index - 1].id;

    putConversationPromptPosition(movedPrompt, positionAfter).then(response => {
      if (!response.ok) {
        refreshConversation();
      }
    })
  }

  function addPrompt() {
    newConversationPrompt(conversationId).then(response => {
      if (response.ok) {
        refreshConversation()
      }
    })
  }

  function deletePrompt(promptDeleteId: string) {
    const index = conversationPrompts.findIndex((p: ConversationPrompt) => p.id === promptDeleteId);
    if (!window.confirm("Delete this prompt?")) {
      return;
    }

    const updatedPrompts = [...conversationPrompts];
    const savedPrompts = [...conversationPrompts];
    if (index != -1) {
      updatedPrompts.splice(index, 1);
      setConversationPrompts(updatedPrompts);
    }

    deleteConversationPrompt(promptDeleteId).then(response => {
      if (!response.ok) {
        refreshConversation()
      }
    });
  }

  function setPrompt(promptUpdate: ConversationPrompt) {
    let prompt = conversationPrompts.find((p: ConversationPrompt) => p.id === promptUpdate.id);
    if (prompt) {
      Object.assign(prompt, promptUpdate)
    }
  }

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, snapshot) => (
          <ul
            {...provided.droppableProps}
            ref={provided.innerRef}
          >
            {conversationPrompts.map((prompt, index) => (
              <Draggable key={prompt.id} draggableId={prompt.id} index={index}>
                {(provided, snapshot) => (
                  <li
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                  >
                    <ConversationPrompt
                      key={`conversation-prompt-${prompt.id}`}
                      prompt={prompt}
                      setPrompt={setPrompt}
                      deletePrompt={deletePrompt}
                    />
                  </li>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
            <li key="prompt-new">
              <div className="row d-inline-flex w-100 ml-0">
                <div className="col-1">
                  &nbsp;
                </div>
                <div className="col-11 text-left pt-2">
                  <Button
                    onClick={() => addPrompt()}
                    variant="primary"
                  >
                    Add Prompt
                  </Button>
                </div>
              </div>
            </li>
          </ul>
        )}
      </Droppable>
    </DragDropContext>
  );
}

function EditConversation(props: { conversation: Conversation, setConversation: any }) {
  const {conversation, setConversation} = props;
  const [name, setName] = useState(conversation.name);
  const [conversationPrompts, setConversationPrompts] = useState<ConversationPrompt[]>([]);

  useEffect(() => {
    refreshConversation()
  }, [conversation.id])

  function refreshConversation() {
    getConversation(conversation.id).then(response => {
      if (response.ok) {
        response.json().then(json => {
          setConversationPrompts(json.conversation.conversationPrompts)
        });
      }
    });
  }

  function setNameAndPut(name: string) {
    const backupName = name;
    const backupConversation = {...conversation}
    setName(name);
    setConversation({...conversation, ...{name: name}})
    // TODO: setConversations([...conversations
    putConversation({...conversation, ...{name: name}}).then(response => {
        if (!response.ok) {
          setName(backupName);
          setConversation(backupConversation);
        }
      }
    );
  }

  return (
    <>
      <div className="row pt-4">
        <div className="col pb-3">
          <EditableText value={name}
                        ariaLabel="Name"
                        isEditable={true}
                        isEditing={true}
                        maxLength={50}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => setNameAndPut(event.target.value)}
                        placeholder="Name of this conversation"
                        setIsEditing={() => {
                        }}/>
        </div>
      </div>
      <ConversationPrompts
        conversationId={conversation.id}
        conversationPrompts={conversationPrompts}
        setConversationPrompts={setConversationPrompts}
        refreshConversation={refreshConversation}
      />
    </>
  )
}

function Conversations(props: { cognitoUser: any }) {
  const {cognitoUser} = props;
  const [conversations, setConversations] = useState([]);
  const [conversation, setConversation] = useState<NullableConversation>(null);
  const [showEditConfig, setShowEditConfig] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [error, setError] = useState<null | ErrorMessageType>(null);

  useEffect(() => {
    refreshConversations()
  }, []);

  function refreshConversations() {
    getConversations().then(response => {
      {
        if (response.ok) {
          response.json().then(json => {
            setConversations(json.conversations);
          });
        }
      }
    });
  }

  function toggleInstructions(event: any) {
    setShowInstructions(!showInstructions);
    event.preventDefault();
  }

  function select(conversation: Conversation) {
    setConversation(conversation);
  }

  function add() {
    newConversation().then(response => {
      if (response.ok) {
        response.json().then(json => {
          setConversation(json.conversation);
        });
      }
    });
  }

  function saveError(json: any) {
    setError(json?.error);
    setTimeout(() => setError(null), 3000)
  }

  const errorMessage =
    error ?
      <div className="row pb-3 error">
        <div className="col-12 text-center">
          {(error as any)?.message}
        </div>
      </div>
      : null;

  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title="Conversations" linkToHome="/home"/>
      <section className="container main conversations p-4 rounded">
        {errorMessage}
        <div className="row">
          <div className="col text-center">
            <DropDownConversations conversations={conversations}
                                   conversation={conversation}
                                   setConversation={setConversation}
                                   add={add}
                                   setShowEditConfig={setShowEditConfig}
                                   toggleInstructions={toggleInstructions}
                                   refreshConversations={refreshConversations}
                                   saveError={saveError}
            />
            {conversation ? <EditConversation conversation={conversation}
                                              setConversation={setConversation}/> : null}
          </div>
        </div>
        <ConversationsInstructions show={showInstructions}
                                   onHide={() => setShowInstructions(false)}/>
        {conversation ?
          <EditConversationConfig conversation={conversation}
                                  setConversation={setConversation}
                                  show={showEditConfig}
                                  onHide={() => setShowEditConfig(false)}
          /> : null}
      </section>
    </>
  );
}

export default Conversations;
